@use '~/theme/theme' as *;
@use '~/theme/typography';

@mixin filter {
  @include typography.body2;
  @include typography.regular;

  padding-top: 7px;
  padding-bottom: 7px;
  text-align: left;
}

.textInput {
  @include filter;

  height: 22px;
}

.selectInput {
  @include filter;
}

.autocompleteInput {
  @include filter;

  height: 19px;
}

.radio {
  padding: 0;
}

.optionIcon {
  margin-left: spacing(1);
}

.amountFilterControl {
  overflow: visible;
}

.amountMenu {
  max-width: 250px;
}

.clearButton {
  padding: 0;
  margin: 0;
}

.amountFilterControl .clearButton {
  height: 22px;
}

.quickSelectionTitle {
  padding: spacing(1) spacing(2);
  background: color(grey-300);
  display: block;
}

.quickSelection {
  flex-direction: row;
  gap: spacing(1);
  cursor: pointer;
}

.categoryControl,
.transactionTypeControl,
.cardHolderControl,
.paymentMethodControl,
.documentTypeControl,
.reconciliationSourceControl,
.documentStatusControl,
.documentPaymentStatusControl {
  min-width: 150px;
  flex-basis: 150px;
}

.menu {
  max-height: 300px;
}

/* stylelint-disable-next-line selector-class-pattern */
.hideIcon :global(.MuiSelect-iconOutlined) {
  display: none;
}

.dateRangeFilter {
  overflow: visible;
  min-width: 150px;
}

.paper {
  background-color: white;
  box-shadow:
    -20px 20px 40px -4px rgb(145 158 171 / 24%),
    0 0 2px 0 rgb(145 158 171 / 24%);
}

.checkbox {
  padding-left: 0;
}

.checkMenuItem {
  padding: spacing(1);
}

.checkIcon {
  @include icon-size(sm);

  padding-left: spacing(0.5);
  opacity: 0;
}

.checked {
  opacity: 1;
}

/* stylelint-disable-next-line selector-class-pattern */
.select :global(.MuiSelect-icon) {
  width: 20px;
  height: 20px;
  margin: 0;
  top: 8px;
}

.option {
  padding-top: spacing(0.75);
  padding-bottom: spacing(0.75);
  margin-bottom: spacing(0.5);
}

.optionLabel {
  color: color(grey-800);
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  margin-left: spacing(1);
}

.formControl {
  overflow: visible;
  min-width: 150px;
  flex: 1 1 150px;
}

.itemIcon {
  margin-right: spacing(1);
}

.listItemText {
  text-align: left;
}
